export default __webpack_public_path__ + "static/media/myreclaim-logo-wh.f805ddf9.png";